module.exports = __webpack_public_path__ + "img/pin-core.83755b60.png";